import { Theme } from "@mui/material/styles";

export const useStyle = (theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  subtitle: {
    fontSize: "16px",
    color: theme.palette.text.secondary,
  },
  header: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  boxInput: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: 1,
  },
  boxIntervalo: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    gap: 2,
  },
  titleInput: {
    fontSize: "1rem",
    fontWeight: 500,
  },
});
